(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('RevisionEvaluativosController', RevisionEvaluativosController);

    RevisionEvaluativosController.$inject = ['$scope', '$state', 'RevisionEvaluativos', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'ClasesAmbitoService','LoginService',
    	'AniosEscolares','InstitucionesClases','NivelesEducativosService','ModelosEducativosService','Periodos'];

    function RevisionEvaluativosController ($scope, $state, RevisionEvaluativos, ParseLinks, AlertService, pagingParams, paginationConstants,ClasesAmbitoService,LoginService,
    		AniosEscolares,InstitucionesClases,NivelesEducativosService,ModelosEducativosService,Periodos) {
        var vm = this;
        
       // vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        //vm.openDialog=openDialog;
     
        vm.indicePeriodo=pagingParams.indice;
        vm.intercurso=pagingParams.ic;
        vm.indiceIntercurso=pagingParams.iic;
        vm.search=search;
        vm.type=pagingParams.type;
        vm.currentSearch=pagingParams.search;
        vm.anioSeleccionado=pagingParams.anio;
        vm.modeloSeleccionado=pagingParams.modelo;
        vm.nivelSeleccionado=pagingParams.nivel;
        vm.institucionSelected=pagingParams.centro;
        vm.evaluacionesPendientes=pagingParams.ep;
        cargarDropdrown();
        loadAll();
        vm.isNew = isNew;
        vm.limpiar = limpiar;
        
        
        
        $scope.$watchGroup(["vm.anioSeleccionado","vm.institucionSelected","vm.intercurso"],function(newValue,oldValue){        	
        	if (newValue != oldValue && vm.anioSeleccionado != null && vm.institucionSelected != null){
	        	vm.periodos = Periodos.query({
	            	anio: vm.anioSeleccionado,
	            	dep: vm.institucionSelected,
	            	ic: vm.intercurso
	            });
        	
	        	if(vm.intercurso == true){
	        		vm.indicePeriodo = 0;
	        	}else{
	        		vm.indiceIntercurso = 0;
	        	}
	        }
        });




        function loadAll () {
        	if(vm.anioSeleccionado != null && vm.institucionSelected != null && vm.intercurso != null){
        		vm.periodos = Periodos.query({
            		anio: vm.anioSeleccionado,
            		dep: vm.institucionSelected,
            		ic: vm.intercurso
                });
        	}
        	
        	RevisionEvaluativos.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                search:  vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro:vm.institucionSelected,
                ep: vm.evaluacionesPendientes,
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
				
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.wrappers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
       

//        function loadPage (page) {
//            vm.page = page;
//            vm.transition();
//        }
        
//        function openDialog () {
//        	var entity={tipo:null
//        	}
//        	ClasesAmbitoService.open(entity);
//        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSelected,
                ep: vm.evaluacionesPendientes,
            },onSuccess,{reload:false});
       	 function onSuccess(data, headers) {
             vm.links = ParseLinks.parse(headers('link'));
             vm.totalItems = headers('X-Total-Count');
             vm.queryCount = vm.totalItems;
             vm.wrappers = data;
             vm.page = pagingParams.page;
         }
        }
        
        function isNew(){
        	if( vm.usuarios.evaluacion.id ==null )
        		return true;
        	else
        		return false;
        }
        
        function cargarDropdrown(){
        	vm.aniosEscolares=AniosEscolares.query();
        	vm.dependencias=InstitucionesClases.query();
        	vm.niveles=NivelesEducativosService.getAll();
        	vm.modelos=ModelosEducativosService.getAll();
        }
        
        function limpiar() {
        	vm.modeloSeleccionado=null;
        }
        
        function search(){
        	
        	if(vm.anioSeleccionado==null )
        		return ;
        	$state.transitionTo($state.$current, {
                page: 0,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                aniostr: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSelected,
                ep: vm.evaluacionesPendientes
            },onSuccess);
            
            
        	 function onSuccess(data, headers) {
                 vm.links = ParseLinks.parse(headers('link'));
                 vm.totalItems = headers('X-Total-Count');
                 vm.queryCount = vm.totalItems;
                 vm.wrappers = data;
                 vm.page = pagingParams.page;
             }
        	
        }

    }
})();
